import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function ProfileView() {
  const { user } = useAuth();

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <div
        style={{
          background: 'linear-gradient(145deg, #101428 0%, #0d0f22 100%)',
          border: '1px solid rgba(159,92,255,0.25)',
          borderRadius: 20,
          padding: 28,
          boxShadow: '0 15px 35px rgba(0,0,0,0.4)',
        }}
      >
        {/* User Avatar + Name */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #9F5CFF 0%, #E34364 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 22,
              fontWeight: 800,
              color: '#fff',
            }}
          >
            {user?.name?.[0]?.toUpperCase() || 'O'}
          </div>
          <div>
            <h2 style={{ margin: '0 0 4px', fontSize: 20, color: '#fff', fontWeight: 800 }}>
              {user?.name}
            </h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, color: '#a0a0b8' }}>{user?.email}</span>
              <span
                style={{
                  background: 'rgba(159,92,255,0.2)',
                  border: '1px solid rgba(159,92,255,0.4)',
                  color: '#9F5CFF',
                  fontSize: 10,
                  fontWeight: 700,
                  padding: '2px 8px',
                  borderRadius: 12,
                  textTransform: 'uppercase',
                }}
              >
                {user?.role_name || user?.role || 'Event Organizer'}
              </span>
            </div>
          </div>
        </div>

        {/* System Capabilities & Permissions */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, color: '#7c7c9c', fontWeight: 700, textTransform: 'uppercase', marginBottom: 8 }}>
            Assigned Permissions
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {user?.permissions?.map((p, i) => (
              <span
                key={i}
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  color: '#00D2FF',
                  fontSize: 11,
                  padding: '4px 10px',
                  borderRadius: 6,
                  fontFamily: 'monospace',
                }}
              >
                ✓ {p}
              </span>
            ))}
          </div>
        </div>

        {/* Operational Emergency Guidelines */}
        <div
          style={{
            background: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: 14,
            padding: '16px',
            marginBottom: 20,
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 700, color: '#fff', marginBottom: 6 }}>
            🚨 On-Site Emergency & Dispatch Support
          </div>
          <p style={{ margin: '0 0 10px', fontSize: 12, color: '#a0a0b8', lineHeight: 1.5 }}>
            Encountering printer jams, power issues, or guest escalations during an event? Contact Pixly Operations Dispatch immediately:
          </p>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <a
              href="tel:18005557495"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                background: 'rgba(227, 67, 100, 0.15)',
                border: '1px solid rgba(227, 67, 100, 0.4)',
                color: '#E34364',
                padding: '8px 14px',
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              📞 Hotline: 1-800-PIXLY-HQ
            </a>
            <a
              href="mailto:operations@pixlybooth.com"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                background: 'rgba(255,255,255,0.05)',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#fff',
                padding: '8px 14px',
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              ✉️ operations@pixlybooth.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
